import {ApiV0AccountIntegrations} from './api.v0.crm.integrations';
import {RestApiService} from '../../../../rest-api.service';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {
    CalendarSourceActionReq,
    CompleteGoogleCalendarIntegrationReq,
    CompleteMicrosoftCalendarIntegrationReq,
    CreateIcsCalendarIntegrationReq, DisconnectCalendarIntegrationReq,
    InitGoogleCalendarIntegrationReq,
    InitMicrosoftCalendarIntegrationReq,
    OAuthInitRes,
    UpdateCalendarSourceSelectionReq,
    VUserCalendarIntegrationRes,
    VUserCalendarIntegrationUReq,
    VUserCalendarSourceRes
} from '../../../../../contracts/v0/account/integrations/account.integrations.calendar.contracts';
import {ApiV0AccountIntegrationsCalendarImport} from './api.v0.crm.integrations.calendar.import';

export class ApiV0AccountCalendarIntegration {

    segment = '/calendar';

    public readonly import: ApiV0AccountIntegrationsCalendarImport;


    constructor(v0: ApiV0AccountIntegrations, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
        this.import = new ApiV0AccountIntegrationsCalendarImport(this, rest);
    }

    search(searchModel?: SearchModel) {
        return this.rest.post<SearchModel, BaseCollectionModel<VUserCalendarIntegrationRes>>(
            `${this.segment}/search`,
            VUserCalendarIntegrationRes,
            searchModel
        );
    }

    get(id: string) {
        return this.rest.get<VUserCalendarIntegrationRes>(
            `${this.segment}/${id}`,
            VUserCalendarIntegrationRes
        );
    }

    update(id: string, req: VUserCalendarIntegrationUReq) {
        return this.rest.patch<VUserCalendarIntegrationUReq, VUserCalendarIntegrationRes>(
            `${this.segment}/${id}`,
            VUserCalendarIntegrationRes,
            req
        );
    }

    refreshSources(id: string) {
        return this.rest.post<void, VUserCalendarSourceRes[]>(
            `${this.segment}/${id}/refreshsources`,
            VUserCalendarSourceRes,
            undefined as void
        );
    }

    saveSourceSelection(id: string, sources: VUserCalendarSourceRes[]) {
        return this.rest.post<VUserCalendarSourceRes[], VUserCalendarSourceRes[]>(
            `${this.segment}/${id}/savesourceselection`,
            VUserCalendarSourceRes,
            [...sources]
        );
    }

    sync(id: string) {
        return this.rest.post<void, void>(
            `${this.segment}/${id}/sync`,
            undefined as any,
            undefined
        );
    }

    test(id: string) {
        return this.rest.post<void, void>(
            `${this.segment}/${id}/test`,
            undefined as any,
            undefined
        );
    }

    updateSelectedSources(id: string, req: UpdateCalendarSourceSelectionReq) {
        return this.rest.patch<UpdateCalendarSourceSelectionReq, void>(
            `${this.segment}/${id}/selectedsources`,
            undefined as any,
            req
        );
    }

    unsubscribeSource(id: string, req: CalendarSourceActionReq) {
        return this.rest.post<CalendarSourceActionReq, void>(
            `${this.segment}/${id}/unsubscribesource`,
            undefined as any,
            req
        );
    }

    removeSource(id: string, req: CalendarSourceActionReq) {
        return this.rest.post<CalendarSourceActionReq, void>(
            `${this.segment}/${id}/removesource`,
            undefined as any,
            req
        );
    }

    disconnect(id: string, req: DisconnectCalendarIntegrationReq = {clearTokens: true}) {
        return this.rest.post<DisconnectCalendarIntegrationReq, void>(
            `${this.segment}/${id}/disconnect`,
            undefined as any,
            req
        );
    }

    createIcsUrl(req: CreateIcsCalendarIntegrationReq) {
        return this.rest.post<CreateIcsCalendarIntegrationReq, VUserCalendarIntegrationRes>(
            `${this.segment}/ics/url`,
            VUserCalendarIntegrationRes,
            req
        );
    }

    initMicrosoftConnect(req: InitMicrosoftCalendarIntegrationReq) {
        return this.rest.post<InitMicrosoftCalendarIntegrationReq, OAuthInitRes>(
            `${this.segment}/microsoft/connect`,
            OAuthInitRes,
            req
        );
    }

    completeMicrosoftConnect(req: CompleteMicrosoftCalendarIntegrationReq) {
        return this.rest.post<CompleteMicrosoftCalendarIntegrationReq, VUserCalendarIntegrationRes>(
            `${this.segment}/microsoft/complete`,
            VUserCalendarIntegrationRes,
            req
        );
    }

    initGoogleConnect(req: InitGoogleCalendarIntegrationReq) {
        return this.rest.post<InitGoogleCalendarIntegrationReq, OAuthInitRes>(
            `${this.segment}/google/connect`,
            OAuthInitRes,
            req
        );
    }

    completeGoogleConnect(req: CompleteGoogleCalendarIntegrationReq) {
        return this.rest.post<CompleteGoogleCalendarIntegrationReq, VUserCalendarIntegrationRes>(
            `${this.segment}/google/complete`,
            VUserCalendarIntegrationRes,
            req
        );
    }
}